import { cn } from '../lib/cn'

export interface AvatarProps {
  /** voller Name – daraus entstehen die Initialen und der zugängliche Name */
  name: string
  /** Bild des Benutzers oder Logo des Mandanten */
  src?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  /** 'square' für Standorte und Mandanten (Radius 6), 'round' für Personen */
  shape?: 'round' | 'square'
  /** Initialen vorgeben (Standortkürzel „ZL“) */
  initials?: string
  /** rein dekorativ, wenn der Name daneben steht */
  decorative?: boolean
  className?: string
}

const SIZE = {
  xs: 'size-5 text-micro tracking-normal',
  sm: 'size-6 text-micro tracking-normal',
  md: 'size-8 text-caption',
  lg: 'size-10 text-dense',
} as const

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase()
}

/** Person oder Standort als Initialen auf accent-muted. */
export function Avatar({ name, src, size = 'md', shape = 'round', initials, decorative, className }: AvatarProps) {
  const a11y = decorative ? ({ 'aria-hidden': true } as const) : ({ role: 'img', 'aria-label': name } as const)
  return (
    <span
      {...a11y}
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden bg-accent-muted font-semibold text-fg select-none',
        shape === 'round' ? 'rounded-full' : 'rounded-sm',
        SIZE[size],
        className,
      )}
    >
      {src ? <img src={src} alt="" className="size-full object-cover" /> : (initials ?? initialsOf(name))}
    </span>
  )
}
